<template>
    <div
        v-if="!note.deleted"
        class="px-4 py-2 border border-gray-100 rounded shadow-sm hover:shadow transition duration-150 flex gap-4 items-start"
    >
        <div class="flex-1">
            <span v-if="note.author" class="block text-xs font-medium text-gray-500 underline pb-2"
                >{{ note.author }} ({{ formatDate(note.createdAt) }})</span
            >
            <p class="whitespace-pre-wrap text-base pl-2 py-1">{{ note.note }}</p>
        </div>
        <button
            @click="deleteNot"
            class="border text-red-500 flex justify-center items-center border-gray-400 hover:border-gray-800 text-xs rounded px-2 py-1"
        >
            {{ $t('Delete') }}
        </button>
    </div>
</template>

<script>
import api from '../lib/api'
import { format } from 'date-fns'
export default {
    props: ['note', 'user'],
    methods: {
        formatDate(dateStr) {
            try {
                return format(new Date(dateStr), 'yyyy-MM-dd HH:MM a')
            } catch (err) {
                return null
            }
        },
        async deleteNot() {
            if (!window.confirm('Delete?')) {
                return
            }
            await api.deleteNotes([this.note.id])
            window.location.reload()
        },
    },
}
</script>
